angular.module('admin.directives')
  .directive('integerInput', [
    function () {
      return {
        restrict: 'A',
        link: function (scope, element, attrs, ngModel) {
          const input = element[0]
          input.oninvalid = () => {
            input.setCustomValidity('Please enter a whole number, no decimals')
          }
          input.oninput = () => {
            input.setCustomValidity('')
          }
        }
      }
    }
  ]
  )
